// Products that go through the Cart Transform test flow instead of the PMS
// draft order. Add or remove product handles here; nothing else needs to change.
export const CART_TRANSFORM_PRODUCT_HANDLES = [
    "seal-skin-pristine-chair-cover-model-4", // Two Seater Patio Couch Covers
    "generator-covers", // Generator Covers
    "rectangular-outdoor-custom-covers", // Custom Rectangular Covers
    "seal-skin-pristine-umbrella-cover", // Custom Umbrella Covers
    "seal-skin-pristine-dining-table-cover-model-4", // Rectangular Table Set Covers
    "seal-skin-pristine-rectangle-accent-cover", // Custom Rectangle Table Accent Covers
    "custom-square-rectangle-covers", // Custom Square/Rectangle Covers
    "custom-tv-covers", // Outdoor TV Covers
    "seal-skin-pristine-round-table-cover-model-2", // Round Patio Table Covers
    "outdoor-air-conditioner-covers", // Outdoor AC Unit Covers

    // Patio Furniture
    "air-hockey-table-covers", // Air Hockey Table Covers
    "custom-poker-table-cover-square-rectangle", // Square/Rectangle Poker Table Covers
    "foosball-table-covers", // Foosball Table Covers
    "seal-skin-pristine-chair-cover-model-12", // Modern Patio Chair Covers
    "seal-skin-pristine-chair-cover-model-16", // Armless Outdoor Chair Covers
    "seal-skin-pristine-chaise-lounge-cover-model-1", // Button Backrest Chaise Lounge Covers
    "seal-skin-pristine-custom-bench-cover-model-7", // High Back Armrest Bench Covers
    "seal-skin-pristine-outdoor-daybed-cover-model-4", // Circular Deep Wall Daybed Covers
    "seal-skin-pristine-outdoor-daybed-cover-model-7", // Rectangular Daybed Covers
    "seal-skin-pristine-oval-table-cover-model-1", // Oval Table Covers
    "seal-skin-pristine-rectangle-ottoman-cover", // Custom Rectangle Ottoman Covers
    "seal-skin-pristine-rectangular-table-top-cover", // Custom Rectangular Table Top Covers
    "seal-skin-pristine-rocking-chair-cover-model-2", // Round Wheel Rocker Covers
    "seal-skin-pristine-rocking-chair-cover-model-6", // High Back Reclining Rocking Chair Covers
    "seal-skin-pristine-rocking-chair-cover-model-9", // Modern Armrest Rocking Chair Covers
    "seal-skin-pristine-square-table-cover-model-2", // Custom Square Bar Table Covers

    // Grill & Heating
    "round-stone-fire-pit-cover", // Round Brick Fire Pit Covers
    "antique-bronze-chiminea-cover", // Antique Bronze Chiminea Covers
    "cupolino-pizza-oven-cover", // Chimney Pizza Oven Covers - Model 2
    "custom-grill-cover", // Custom Grill Covers
    "dome-shape-fire-pit-cover", // Round Mesh Fire Bowl Covers
    "griddle-with-folding-legs-cover", // Two Burner Griddle with Side Shelf Covers
    "l-shape-outdoor-bar-island-cover-model-1", // L Shape Outdoor Counter Island Covers - Left
    "log-hoop-firewood-rack-cover", // Hoop Firewood Rack Covers
    "modern-geometric-chiminea-cover", // Angular Chiminea Covers
    "outdoor-brick-bar-island-cover", // Outdoor Brick Counter Island Covers
    "rectangle-firewood-rack-cover", // Rectangle Firewood Rack Covers
    "round-low-base-fire-cover", // Round Fire Bowl Covers
    "sleek-modern-fire-bowl-cover", // Round Modern Fire Bowl Covers

    // Industrial & Equipment
    "custom-master-lock-portable-electric-winch-cover", // Master Lock Electric Cable Winch Covers
    "custom-rmu-cover-round", // Round RMU Enclosure Covers
    "custom-warn-axon-winch-cover", // Cable Hook Winch Covers
    "ibc-tote-cover", // IBC Tank Covers
    "ice-cream-machine-cover", // Ice Cream Machine Covers
    "kiosk-covers", // Kiosk Covers
    "multi-gym-equipment-covers", // Smith Machine Covers
    "outdoor-scoreboard-covers", // Outdoor Scoreboard Covers
    "pressure-washer-with-hose-reel-cover", // Wheeled Pressure Washer Covers - Model 2
    "stationary-exercise-bike-covers", // Stationary Exercise Bike Covers
    "two-tier-utility-cart-cover", // Two-Shelf Rolling Cart Covers - Model 1

    // Custom Covers
    "curved-outdoor-custom-covers", // Custom Curved Covers
    "pyramid-outdoor-custom-covers", // Custom Pyramid Covers
    "rectanglular-outdoor-custom-covers-with-round-edges", // Custom Rectangular Covers with Round Edges
    "semi-circle-shaped-outdoor-custom-covers", // Custom Semi-Circle Shaped Covers
    "u-shape-outdoor-custom-covers", // Custom U Shaped Covers
    "u-shape-slanted-outdoor-custom-covers", // Custom U Shaped Slanted Covers
];

// Line attribute that marks a cart line as using the Cart Transform flow.
export const CART_TRANSFORM_FLAG = "_cart_transform";

export const isCartTransformHandle = (handle) => CART_TRANSFORM_PRODUCT_HANDLES.includes(handle);

export const isCartTransformLine = (item) => (item?.node?.attributes || [])
    .some((attr) => attr.key === CART_TRANSFORM_FLAG && attr.value === "Yes");
